<template>
  <div class="overflow-hidden">
    <div class="flex w-full items-center justify-between pr-4">
      <div class="shimmer h-6 w-32 rounded-xl"></div>
    </div>
    <div class="relative pt-4">
      <div class="-mx-4 flex space-x-3 px-4">
        <div
          v-for="i in 2"
          :key="i"
          class="shimmer h-[200px] min-w-64 rounded-2xl"
        ></div>
      </div>
    </div>
    <div class="shimmer mt-4 h-12 w-full rounded-2xl"></div>
  </div>
</template>
